import { axiosInstance } from "@/lib/api/client";

export const getFormConfigurationsByType = async (formType: string) =>
  axiosInstance
    .get(`/form-configurations?type=${formType}`)
    .then((response) => response.data?.member || []);
